
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import { dataSource_topicManagerFilter } from '@xt/client/dataSource/kindred-spirit'
import { EumJoinStatus } from '@xt/client/enums/kindred-spirit'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    HeaderImage
  },
  async asyncData(ctx) {
    // 是否是负责人前置校验
  }
})
export default class ManagerPage extends Vue {
  city: string = '杭州分桐'
  statistics: Array<{
    key: 'member' | 'join' | 'exit'
    label: string
    count: number
  }> = [
    {
      key: 'member',
      label: '成员总数',
      count: 0
    },
    {
      key: 'join',
      label: '等待入群',
      count: 0
    },
    {
      key: 'exit',
      label: '退出审核',
      count: 0
    }
  ]
  memberSum: number = 0
  searchValue: string = ''
  filterValue: string = ''

  dataSource: Array<{
    memberId: string
    nickName: string
    status: number
    subText: string
    specail: string[]
  }> = [
    {
      memberId: '1',
      nickName: '潜水一号',
      status: 0,
      subText: '等待入群·已加入2天',
      specail: ['国画爱好', '写字']
    },
    {
      memberId: '1',
      nickName: '潜水一号',
      status: 0,
      subText: '等待入群·已加入2天',
      specail: ['国画爱好', '写字']
    }
  ]

  get filterLabel() {
    const i = lodash.find(dataSource_topicManagerFilter, ['key', this.filterValue])
    return i ? i.label : dataSource_topicManagerFilter[0].label
  }

  get sortOptions() {
    return dataSource_topicManagerFilter
  }

  handleFilter({ key, domEvent }: { key: EumJoinStatus; domEvent: MouseEvent }) {
    // 防止点击下拉菜单再次弹出
    domEvent.stopPropagation()

    if (this.filterValue === key) return

    this.filterValue = key
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
